import { render, staticRenderFns } from "./BlackPearlField.vue?vue&type=template&id=63780016&"
import script from "./BlackPearlField.vue?vue&type=script&lang=ts&"
export * from "./BlackPearlField.vue?vue&type=script&lang=ts&"
import style0 from "./BlackPearlField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports